module.exports = __webpack_public_path__ + "media/images/dummy_item12-f62ef9a97e06c6050dc0eb83932744a9.jpg";